import { Injectable } from "@angular/core";
import { CacheService } from "@apps/patient-core/src/app/services/cache.service";
import { E_PatientFeatures } from "@backend/common/enums/feature-flags.enum";
import { IFeatureFlags } from "@backend/common/interfaces/feature-flags.interface";

const CACHE_KEY = "feature-flags";

@Injectable({
  providedIn: "root",
})
export class FeatureFlagsService {
  constructor(private _cacheService: CacheService) {}

  /**
   * Stores feature flags
   *
   * @param featureFlags Feature flags
   */
  public setFeatureFlags(featureFlags: IFeatureFlags): void {
    this._cacheService.set(CACHE_KEY, JSON.stringify(featureFlags));
  }

  public getFeatureFlagValue<T>(feature: E_PatientFeatures, defaultValue: T): T {
    try {
      return this._getFeatureFlag<T>(feature);
    } catch {
      return defaultValue;
    }
  }

  public get patientGpDetails(): boolean {
    try {
      return this._getFeatureFlag<boolean>(E_PatientFeatures.PATIENT_GP_DETAILS);
    } catch {
      return false;
    }
  }

  public get emergencyContact(): boolean {
    try {
      return this._getFeatureFlag<boolean>(E_PatientFeatures.EMERGENCY_CONTACT);
    } catch (e) {
      return false;
    }
  }

  /**
   * Gets the value of a feature flag
   *
   * @param featureFlag Feature for which to get the value
   */
  private _getFeatureFlag<T>(featureFlag: string): T {
    const json = this._cacheService.get(CACHE_KEY);

    if (!json) throw "No feature flags found";

    const featureFlags = JSON.parse(json);

    if (featureFlags[featureFlag] === undefined) throw "Feature flag not set";

    return featureFlags[featureFlag] as T;
  }
}
